const initialState = {
    display_name: null,
    customer_search_box_label: null,
    merchant_logo: null,
    minimum_accept_amount_for_payment: null,
    customer_search_box_note: null,
    search_box_placeholder_label: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DISPLAY_NAME':
            return {
                ...state,
                display_name: action.payload,
            };
        case 'CUSTOMER_SEARCH_BOX_LABEL':
            return {
                ...state,
                customer_search_box_label: action.payload,
            };
        case 'CUSTOMER_SEARCH_BOX_NOTE':
            return {
                ...state,
                customer_search_box_note: action.payload,
            };
        case 'MERCHANT_LOGO':
            return {
                ...state,
                merchant_logo: action.payload,
            };
        case 'MINIMUM_ACCEPT_AMOUNT_FOR_PAYMENT':
            return {
                ...state,
                minimum_accept_amount_for_payment: action.payload,
            };

        case 'SEARCH_BOX_PLACEHOLDER_LABEL':
            return {
                ...state,
                search_box_placeholder_label: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
